import React from "react";
import PropTypes from "prop-types";
import { formatCurrency } from "@wrstudios/utils";
import { getAverageAdjustedPrice } from "../../../utils/listings";
import IllustrationAveragePricing from "../../illustrations/IllustrationAveragePricing";
import { useLive } from "../LiveProvider";
import Preview from "./LivePreview";

function LivePreviewAveragePricing({ title }) {
  const { visibleListings } = useLive();
  const soldListings = visibleListings.filter((listing) => listing.soldPrice);
  const averageAdjustedPrice = getAverageAdjustedPrice(soldListings);

  return (
    <Preview
      illustration={<IllustrationAveragePricing />}
      title={title}
      subTitle={
        averageAdjustedPrice ? formatCurrency(averageAdjustedPrice) : "N/A"
      }
    />
  );
}

LivePreviewAveragePricing.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewAveragePricing;
